/**
 * ArtifactType represents the classification of an artifact.
 *
 * Note: This is a temporary static enum. Once the Platform API provides this,
 * it should be replaced.
 */
export enum ArtifactType {
  Image = 'image',
  SBOM = 'sbom',
  Source = 'source',
}
